// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  googleAuth: '353837142333-4pgc1fj0adbm9i7ed0v0u0infjikcdo7.apps.googleusercontent.com',
  version: '3.1.1',
  sentryURL: 'https://4888d1417dc54de696a55e89847c062f@o1170162.ingest.sentry.io/4504060006760448'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
